import { ECR_PROCESS_LOCATIONS } from "api/memberPortal/ecr/ecrOptions.types";

import { EcrFormInput } from "../Ecr.schema";

/**
 * Default values for the ECR form - used by withForm for type inference.
 * Actual runtime values come from the parent form instance.
 */
export const ecrFormDefaultValues = {
  product: undefined,
  title: "",
  process_location: ECR_PROCESS_LOCATIONS.CHECK_OUT,
  type: "",
  status: "",
  documentTypes: [],
  cite: "",
  fileType: "",
  documentVisibility: "",
  fileLabel: "",
  files: [],
  comment: "",
  rationale: "",
  protectionProfile: undefined,
  technicalDecisions: [],
  requirement: "",
} as EcrFormInput;
